import { UseFormReturn } from "react-hook-form";
import { ProcurementFormValues } from "../schema";
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from "@/components/ui/form";
import { Switch } from "@/components/ui/switch";
import { Input } from "@/components/ui/input";
import { Building2 } from "lucide-react";

interface BankInformationSectionProps {
  form: UseFormReturn<ProcurementFormValues>;
}

export const BankInformationSection = ({ form }: BankInformationSectionProps) => {
  const useDifferentBank = form.watch("use_different_bank") || false;

  return (
    <div className="space-y-4">
      <FormField
        control={form.control}
        name="use_different_bank"
        render={({ field }) => (
          <FormItem className="flex flex-row items-center justify-between rounded-lg border p-4">
            <div className="space-y-0.5">
              <FormLabel className="flex items-center gap-2 text-base">
                <Building2 className="h-4 w-4" />
                Use different bank information
              </FormLabel>
              <p className="text-sm text-muted-foreground">
                Enable if payment should go to a different bank account than the supplier's default
              </p>
            </div>
            <FormControl>
              <Switch
                checked={field.value}
                onCheckedChange={field.onChange}
              />
            </FormControl>
          </FormItem>
        )}
      />

      {useDifferentBank && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 p-4 border rounded-lg bg-muted/20">
          <FormField
            control={form.control}
            name="bank_name"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Bank Name *</FormLabel>
                <FormControl>
                  <Input 
                    placeholder="e.g., Commercial Bank of Ethiopia" 
                    {...field} 
                    value={field.value || ""}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="bank_account"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Bank Account Number *</FormLabel>
                <FormControl>
                  <Input 
                    placeholder="e.g., 1000123456789" 
                    {...field}
                    value={field.value || ""}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="bank_branch"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Bank Branch</FormLabel>
                <FormControl>
                  <Input 
                    placeholder="e.g., Bole Branch" 
                    {...field}
                    value={field.value || ""}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="account_holder_name"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Account Holder Name</FormLabel>
                <FormControl>
                  <Input 
                    placeholder="e.g., ABC Trading PLC" 
                    {...field}
                    value={field.value || ""}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </div>
      )}
    </div>
  );
};
